/**
 * Which signature states allow what. How a letter's status READS is `letterStatus.ts`: one set of
 * words for the lists and the draft header.
 */
import type { SignatureState } from '../../types/referenceLetterDraft';

/** With the signatory, or past it: a new send is refused, and the letter is not "ready to draft". */
export const WITH_SIGNATORY: ReadonlySet<SignatureState> = new Set(['sending', 'out', 'uncertain', 'signed']);

/** States from which "Send for signature" is offered (again). */
export const SENDABLE: ReadonlySet<SignatureState> = new Set(['none', 'failed', 'declined', 'expired', 'canceled']);
